const pad = (n) => String(n).padStart(2, "0");
export const localToday = () => { const d = new Date(); return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; };
const toUtc = (s) => { const [y, m, d] = s.split("-").map(Number); return Date.UTC(y, m - 1, d); };
export const daysUntil = (s) => Math.round((toUtc(s) - toUtc(localToday())) / 86400000);
export const fmtDay = (s) => new Date(`${s}T12:00:00`).toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" });
export const countdownLabel = (s) => { const n = daysUntil(s); return n === 0 ? "Today" : n === 1 ? "Tomorrow" : `${n} days`; };
